import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const CM_INSTRUCTOR_QUOTE_I18N_NAMESPACE =
  '@mc/next/experiments/pen-7315_v1_cm_instructor_quote'

export const i18nInstance = registerI18nResources({
  namespace: CM_INSTRUCTOR_QUOTE_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
